import { MessageType } from './message-type';
export class Message<T> {
    constructor(public data: T, public type = MessageType.Message, public uuid = '') { }
}
